import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient, private router: Router) {}

    updateName(name: string): Observable<any> {
      return this.http.post(`${environment.apiUrl}users/update-name`, { name })
        .pipe(
          tap((response: any) => {
          })
        );
    }

    updatePhone(phone: string): Observable<any> {
      return this.http.post(`${environment.apiUrl}users/update-phone`, { phone })
        .pipe(
          tap((response: any) => {
          })
        );
    }

    updatePassword(oldPassword: string, newPassword: string): Observable<any> {
      return this.http.post(`${environment.apiUrl}users/update-password`, { oldPassword, newPassword })
        .pipe(
          tap((response: any) => {
          })
        );
    }
}
